/*
 * Created Date: 17-01-2024, 1:59:50 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'

export const PLAN_FEATURES = {
	free_exam: 'free-exam',
	free_question: 'free-question',
	free_exam_onthi_mode: 'free-exam-onthi-mode',
	free_exam_test_mode: 'free-exam-test-mode'
}

class Plan extends BaseService {
	BASE_ENDPOINT = '/workspace/public/api/v1/plans'

	BASE_URL = 'https://studio-api-07.eduquiz.io.vn'

	constructor(params) {
		super(params)
		this.setRequest()
	}

	/**
	 * Get all resource for paginate
	 * @param {}
	 * @returns
	 */
	list = (query = {}, config = {}) => {
		const params = { ...this.paramsGet, ...query }
		return this.withCache(() => this.request.get(this.BASE_ENDPOINT, { params, ...config }), this.BASE_ENDPOINT)
	}

	getCurrentPlanSubscription = () => {
		const endpoint = '/workspace/studio/api/v1/user/current-plan-subscription'
		return this.request.get(endpoint)
	}

	activePlanFree = data => {
		const endpoint = '/workspace/studio/api/v1/user/active-plan-free'
		return this.request.post(endpoint, data)
	}

	// getCurrentPlan = () => {
	// 	const endpoint = '/core/api/v1/user/current-plan'
	// 	return this.request.get(endpoint)
	// }

	getFeatureRemaining = slug => {
		const endpoint = `/workspace/studio/api/v1/user/feature-remaining/${slug}`
		return this.request.get(endpoint)
	}

	/**
	 * Tăng số lượt đã sử dụng
	 * new PlanFeature(['name' => 'exam', 'value' => 10, 'sort_order' => 1]),
            new PlanFeature(['name' => 'question', 'value' => 1000, 'sort_order' => 5]),
            new PlanFeature(['name' => 'onthi_mode', 'value' => 50, 'sort_order' => 10, 'resettable_period' => 1, 'resettable_interval' => 'month']),
            new PlanFeature(['name' => 'test_mode', 'value' => 5, 'sort_order' => 10, 'resettable_period' => 1, 'resettable_interval' => 'month']),
	 * Display a listing of the resource.
	 * @return Response
	 */
	recordFeatureUsage = data => {
		const endpoint = '/core/api/v1/user/plans/record-feature'
		return this.request.post(endpoint, data)
	}

	/**
	 * Giảm số lượt sử dụng
	 *
	 * Display a listing of the resource.
	 * @return Response
	 */
	reduceFeatureUsage = data => {
		const endpoint = '/core/api/v1/user/plans/reduce-feature'
		return this.request.post(endpoint, data)
	}

	cancelOrder = id => {
		const endpoint = `/workspace/studio/api/v1/admin/orders/${id}/cancel-order`
		return this.request.post(endpoint)
	}

	getCurrentFeatureUsage = () => {
		const endpoint = '/workspace/studio/api/v1/admin/plan/current-subscription-usage'
		return this.request.get(endpoint)
	}
}

const planService = new Plan()
export default planService
